import { useChat } from './ChatProvider';
import { DisplayNameSettings } from './PersonalSettings';
import { managementRequest } from '../settings/ChatSettings';
export function AccountAvatar({ initial, expanded, onClick }) {
  const { currentUser } = useChat();
  return (
    <button
      className="account-avatar"
      aria-label="Edit display name"
      title={currentUser?.name}
      aria-expanded={expanded}
      onClick={onClick}
    >
      {initial || '?'}
    </button>
  );
}
export function AccountEditor({ onClose }) {
  const { currentUser, refreshDirectory, error } = useChat();
  return currentUser ? (
    <DisplayNameSettings
      name={currentUser.name || currentUser.username || ''}
      request={managementRequest}
      onCancel={onClose}
      onSaved={async () => {
        await refreshDirectory();
        onClose();
      }}
    />
  ) : (
    <div className="account-editor" role={error ? 'alert' : 'status'}>
      {error?.message || 'Loading account…'}
      <button onClick={() => void refreshDirectory()}>Retry</button>
      <button onClick={onClose}>Cancel</button>
    </div>
  );
}
